export const DEFAULT_SIDEBAR_WIDTH = 448;
export const MIN_SIDEBAR_WIDTH = 320;
export const MAX_SIDEBAR_WIDTH = 800;
export const MIN_CONTENT_WIDTH = 320;
export const SIDEBAR_WIDTH_STORAGE_KEY = "workspace.sidebarWidth";

export const maxSidebarWidth = (viewportWidth: number) =>
  Math.max(MIN_SIDEBAR_WIDTH, Math.min(MAX_SIDEBAR_WIDTH, viewportWidth - MIN_CONTENT_WIDTH));

export const clampSidebarWidth = (width: number, viewportWidth: number) =>
  Math.min(Math.max(width, MIN_SIDEBAR_WIDTH), maxSidebarWidth(viewportWidth));
